import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { SCRAPE_CATEGORY_CACHE_KEY } from "./keys";

import { ScrapedCategoryFilters } from "@/types/scrape-category";
import { ScrapedCategoryRepository } from "@/repositories/scrape-category";

export const useGetScrapeCategories = (filters: ScrapedCategoryFilters) => {
  const scrapedCategoryRepository = useRef(new ScrapedCategoryRepository());

  return useQuery({
    queryKey: SCRAPE_CATEGORY_CACHE_KEY.LIST(filters),
    queryFn: async () => {
      return await scrapedCategoryRepository.current.findAll(filters);
    },
    placeholderData: keepPreviousData,
  });
};
